import { Alert } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"

export function RegimeDraftLockBanner() {
    const { isRegimeDraftLocked } = useBoundContext()
    if (!isRegimeDraftLocked) return null
    return (
        <If field="activeStep.props.id" equals="Draft">
            <Alert severity="info" sx={{ my: 1 }} data-cy="regime-draft-locked-alert">
                This draft is locked while the previous changes are under review.
            </Alert>
        </If>
    )
}
